module.exports = "<div class=\"row mt-2\">\n  <h1 class=\"text-uppercase\">camera</h1>\n  <div class=\"camera-list col-12\">\n    <button class=\"btn camera-item\"\n      *ngFor=\"let c of cameras\"\n      [class.active]=\"currentCamera?.id === c.id\"\n      (click)=\"selectCamera(c)\">\n      {{ c.posName }}\n    </button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/camera-selector/camera-selector.component.html
// module id = ./src/app/shared/components/camera-selector/camera-selector.component.html
// module chunks = main